import { useQuery, gql } from "@apollo/client";
import { Image } from "react-bootstrap";

import DeejayThumbnail from "@/components/DeejayThumbnail";
import { useUser } from "@/components/contexts/user";
import Playlists from "@/components/shows/Playlists";
import Loader from "@/components/common/Loader";
import Seo from "@/components/seo";
import handleServerSideProps from "src/lib/handle-server-side-props";

export async function getServerSideProps({ params, ...context }) {
  if (!parseInt(params.id)) return { notFound: true };
  const { data, result } = await handleServerSideProps({
    context,
    pageQuery,
    variables: { id: params.id },
    props: { id: params.id },
  });
  if (!data.showById) return { notFound: true };

  // Pass post data to the page via props
  return result;
}

function ShowPage({ id }) {
  // Our initial query
  const user = useUser();
  const { data } = useQuery(pageQuery, { variables: { id } });

  if (!data) return <Loader />;

  const { show } = {
    show: data.showById,
  };

  return (
    <div className="container">
      <Seo title={`${show.showName} | Shows`} />
      <div className="text-center">
        {show.banner && (
          <Image
            src={show.banner}
            className="show-banner"
            alt={`${show.showName} banner`}
            fluid
          />
        )}
      </div>
      <h1>
        <b>{show.showName}</b>
      </h1>
      {user.isAuthenticated ? (
        <p id="dj-name-label">
          {" "}
          -{" "}
          <strong>
            <a href={`/show/${show.id}/edit/`}>EDIT</a>
          </strong>
        </p>
      ) : null}
      <p>
        <em>
          {show.dayOfWeek} from {show.startTime} to {show.endTime}
        </em>
      </p>
      <div dangerouslySetInnerHTML={{ __html: show.description }} />
      <h4>Host{show.dj.length > 1 && "s"}</h4>
      <div className="row row-cols-3">
        {show.dj.map((dj) => (
          <div key={dj.id} className="col mb-3">
            <DeejayThumbnail dj={dj} />
          </div>
        ))}
      </div>
      <Playlists showId={id} />
    </div>
  );
}

export default ShowPage;

const pageQuery = gql`
  query ($id: ID!) {
    showById(id: $id) {
      __typename
      id
      dayOfWeek
      startTime
      endTime
      description
      showName
      banner
      # banner {
      #   width
      #   height
      #   url
      # }
      dj {
        __typename
        id
        pic
        dj
        url
      }
      # playlists
    }
  }
`;
